import { useQuery } from '@apollo/client';
import { GET_VIEWPOINT_DETAIL, QuerySuccessResponse, QueryVariables } from './query';

export const useBasicViewpointDetails = (id: string | null) => useQuery<QuerySuccessResponse, QueryVariables>(
  GET_VIEWPOINT_DETAIL, {
    variables: { id },
  });
